import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui-kit/button';
import { Textarea } from '@/components/ui-kit/textarea';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui-kit/form';
import { translatedZodResolver } from '@/lib/utils/validation/translated-zod-resolver';
import { useCreatePotentialProfile } from '../../hooks/use-profiles';
import { profileFormSchema, ProfileFormValues } from '../../schemas/profile-form-schema';
import { candidateFormDefaults } from '../../../shared/candidate-form-schema';
import { CandidateFields } from '../../../shared/components/candidate-fields';

export const ProfileForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync: createPotentialProfile, isPending } = useCreatePotentialProfile();

  const form = useForm<ProfileFormValues>({
    resolver: translatedZodResolver(profileFormSchema, t),
    defaultValues: candidateFormDefaults,
  });

  const handleSubmit = async (values: ProfileFormValues) => {
    try {
      await createPotentialProfile(values);
      navigate('/hr/potential-profiles');
    } catch {
      // Error toast is already shown by the mutation's global error handler.
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="flex w-full flex-col gap-5">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <CandidateFields />
        </div>

        <FormField
          control={form.control}
          name="Comment"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('COMMENT')}</FormLabel>
              <FormControl>
                <Textarea rows={3} placeholder={t('COMMENT')} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex justify-end gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => navigate('/hr/potential-profiles')}
          >
            {t('CANCEL')}
          </Button>
          <Button type="submit" loading={isPending} disabled={isPending}>
            {t('CREATE')}
          </Button>
        </div>
      </form>
    </Form>
  );
};
